export default __webpack_public_path__ + "static/media/keto@3x.25b9c157.png";